import { CATALYST_COLORS_WITH_HEXCODES } from "@certa/catalyst/constants/styles";
import { BoxNode } from "../engines/renderingEngine/primitiveNodes";
import type { BoxProps } from "../engines/coreComponents/types";

export const VERTICAL_DROP_INDICATOR_WIDTH = 2;

export const VerticalDropIndicator = () => {
  return BoxNode({
    key: "VerticalDropIndicator",
    style: verticalDropIndicatorStyle,
    children: []
  });
};

const verticalDropIndicatorStyle: BoxProps["style"] = {
  width: VERTICAL_DROP_INDICATOR_WIDTH,
  height: "100%",
  backgroundColor: CATALYST_COLORS_WITH_HEXCODES.NEUTRAL_800
};
